import {Box, Button, Card, CardContent, CardHeader, Chip, Grid, Typography} from "@mui/material";
import {BreadcrumbItem, BreadcrumbLink, Breadcrumbs, TemporalFormat, tryParseInstant, View, ViewHeader} from "@variocube/app-ui";
import React from "react";
import {useAsync} from "react-async-hook";
import {Link} from "react-router-dom";
import {useCreditCardApi} from "../../api";
import {useLocalization} from "../../i18n";
import {formatCreditCardNumber} from "../../utils/formatCreditCardNumber";
import {useNumericParam} from "../../utils/useParam";

export function CreditCardView() {
	const id = useNumericParam("id");
	const {t} = useLocalization();
	const {getCreditCard} = useCreditCardApi();

	const {loading, error, result} = useAsync(getCreditCard, [id]);

	const cardNumber = formatCreditCardNumber(result?.cardNumber ?? "");

	return (
		<View loading={loading} error={error}>
			<Breadcrumbs>
				<BreadcrumbLink component={Link} to={".."} relative="path">{t("creditCards.plural")}</BreadcrumbLink>
				<BreadcrumbItem>{cardNumber}</BreadcrumbItem>
			</Breadcrumbs>
			<ViewHeader
				title={cardNumber}
				titleAdornment={
					<Chip
						label={t(`common.${result?.active ? "active" : "inactive"}`)}
						color={result?.active ? "success" : "error"}
					/>
				}
				subTitle={result?.user.displayName}
				actions={
					<Button color="primary" variant="outlined" component={Link} to="edit">
						{t("creditCards.edit.title")}
					</Button>
				}
			/>
			<Box>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={6} md={4}>
						<Card>
							<CardHeader title={t("creditCards.creditCardCompany")} />
							<CardContent>
								<Typography variant="body1">{result?.creditor.companyName}</Typography>
								<Typography variant="body2">{result?.creditor.sapCreditorNumber}</Typography>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={12} sm={6} md={4}>
						<Card>
							<CardHeader title={t("creditCards.user")} />
							<CardContent>
								<Typography variant="body1">{result?.user.displayName}</Typography>
								<Typography variant="body2">{result?.user.email}</Typography>
								<Typography variant="body2">{result?.inbox.name}</Typography>
							</CardContent>
						</Card>
					</Grid>
					<Grid item xs={12} sm={6} md={4}>
						<Card>
							<CardHeader title={t("creditCards.lastVerified")} />
							<CardContent>
								<Typography variant="body1">
									<TemporalFormat value={tryParseInstant(result?.lastVerified)} />
								</Typography>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Box>
		</View>
	);
}
